import {
    ALLOCATION_GROUPS,
    EXPERIMENTS,
    getAllocatedGroup,
    type AbTests,
} from '@fiverr-private/briefs_experiments_utils';
import type { MiraBriefLobbyButtonVariant } from '@fiverr-private/mira_entry_points';

const MIRA_BRIEF_LOBBY_BUTTON_VARIANTS: Record<number, MiraBriefLobbyButtonVariant> = {
    [ALLOCATION_GROUPS.B]: 'chat',
    [ALLOCATION_GROUPS.C]: 'miniFlow',
    [ALLOCATION_GROUPS.D]: 'orbit',
};

/**
 * Mira entry points experiment: group A (control) or not allocated → null (the current Mira button).
 * Groups B-D render MiraBriefLobbyButton (chat / miniFlow / orbit).
 */
export const getMiraBriefLobbyButtonVariant = (abTests?: AbTests): MiraBriefLobbyButtonVariant | null =>
    MIRA_BRIEF_LOBBY_BUTTON_VARIANTS[getAllocatedGroup(EXPERIMENTS.MIRA_ENTRY_POINTS_V1, abTests)] ?? null;
